var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseEditableCard,{staticClass:"contest-offer-card",attrs:{"is-show-edit-buttons":false,"is-loading":_vm.isLoading}},[_vm._t("header"),_vm._t("goals")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }